import { useEffect } from 'react';

const ACTIVITY_EVENTS = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll', 'focus'];

/**
 * Locks the app after a period of inactivity so an unattended computer in a
 * staff room never leaves student records on screen.
 */
export function useIdleLock(onIdle: () => void, timeoutMs = 15 * 60 * 1000): void {
  useEffect(() => {
    let timer = window.setTimeout(onIdle, timeoutMs);

    const reset = () => {
      window.clearTimeout(timer);
      timer = window.setTimeout(onIdle, timeoutMs);
    };

    ACTIVITY_EVENTS.forEach((event) => window.addEventListener(event, reset, { passive: true }));

    return () => {
      window.clearTimeout(timer);
      ACTIVITY_EVENTS.forEach((event) => window.removeEventListener(event, reset));
    };
  }, [onIdle, timeoutMs]);
}
